module.exports = __webpack_public_path__ + "static/media/pay-land.7a120bcc.jpg";